export default __webpack_public_path__ + "static/media/mice.51b33fc0.svg";